export const MOBILE_SETTINGS = '/mobile-settings'
